import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import {RiAddCircleFill} from 'react-icons/ri';
import { FaTimesCircle, FaRegTrashAlt } from "react-icons/fa";
import { IoMdAddCircle} from 'react-icons/io';
import { MdEdit } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { LuX } from "react-icons/lu";
import { IoMdSync } from "react-icons/io";


import { addAndRemoveLoadingIcon, swapSVGWhileProcessing } from '../item_page/driver_page_components/payoutAdjustmentsSection';
import styles from './buttons.module.scss';


const AddButtonWrapper = styled.div`
    opacity:  ${props => props.inactive?'0.5': "1.0"};
    color:var(--main-color);
    display:flex;
    align-items:center;
    justify-content:center;
    &>svg{
        height:${props => props.$size ? props.$size : "2rem"};
        width:${props => props.$size ? props.$size : "2rem"};
        cursor:${props => props.inactive?'default': "pointer"};
    }
`
const RmvBtn = styled.div`
    opacity:${props => props.$disabled ? "0.5" : ""};
    cursor:${props => props.$disabled ? "" : "pointer"};
    color:${props => props.$customcolor ?props.$customcolor : "var(--alert-color)"};
    display:flex;
    justify-content:center;
    align-items:center;
    
`;
const AddButtonWithText = styled.div`
    color:var(--main-color);
    display:flex;
    font-weight:bolder;
    align-items:center;
    &>svg{
        width:1.5rem;
        height:1.5rem;
        color:var(--main-color);
    }
`;
const threeDotsHovered = `
background-color:var(--bg);
box-shadow: var(--button-outline);
-moz-box-shadow: var(--button-outline);
-webkit-box-shadow: var(--button-outline);
-webkit-transition: all 0.3s ease-in;
-moz-transition: all 0.3s ease-in;
-o-transition: all 0.3s ease-in;
transition: all 0.3s ease-in;
&>span:not(:nth-child(3)){
    border-right: thin solid var(--lighter-gray);
    transition: all 0.3s ease-in;
    opacity:1.0;
    cursor:pointer;
}
`
const unhovered = `
&>span:not(:nth-child(3)){
    cursor:default;
    opacity:0.0;
    border-right: thin solid rgba(0, 0, 0, 0);
}
`
const EditButtonWrapper = styled.div`
    margin-right:0.1rem;
    position:${props => props.$position ? props.$position : "relative"};
    height:100%;
    display:flex;
    justify-content:end;
    opacity:${props => props.$disabled ? "0.5" : ""};
    &>div{
        position:absolute;
        margin-top:-0.3rem;
        &>div{
            display:flex;
            align-items:left;
            justify-content:end;
            &>span:last-child{
                cursor:${props => props.$disabled ? "" : "pointer"};
            }
            svg{
                width:1.3rem;
                height:1.3rem;
                color:var(--gray);
            }
            border-radius:0.4rem;
            &>span{
                width:2.5rem;
                height:1.8rem;
                display:flex;
                align-items:center;
                justify-content:center;
            }
            ${props => props.$hovered ? `
                background-color:var(--bg);
                box-shadow: var(--button-outline);
                -moz-box-shadow: var(--button-outline);
                -webkit-box-shadow: var(--button-outline);
                -webkit-transition: all 0.3s ease-in;
                -moz-transition: all 0.3s ease-in;
                -o-transition: all 0.3s ease-in;
                transition: all 0.3s ease-in;
                &>span:not(:last-child){
                    border-right: thin solid var(--lighter-gray);
                    transition: all 0.3s ease-in;
                    opacity:1.0;
                    cursor:pointer;
                }
            ` : `
                &>span:not(:last-child){
                    cursor:default;
                    opacity:0.0;
                    border-right: thin solid rgba(0, 0, 0, 0);
                }
            `}
        }
        
    }
    
`;

const TaskListEditButtonWrapper = styled.div`
    display:flex;
    align-items:left;
    justify-content:end;
    position:${props => props.$top ? props.$position : ''};
    top:${props => props.$top ? props.$top : ''};
    left:${props => props.$left ? props.$left : ''};
    &>span:nth-child(3){
        cursor:pointer;
        ${props => props.$vertical ? "transform: rotate(90deg);" : ''}
    }
    svg{
        color:var(--gray);
        display: block;
        margin: 0 auto;
    }
    border-radius:0.4rem;
    &>span{
        vertical-align: middle;
        padding:0.3rem;
    }
    
    ${props => props.$hovered ? 
        `${props.$customBackgroundColor ? `background-color:${props.$customBackgroundColor};`:null}
        ${threeDotsHovered}`
    :
        unhovered
    }
`;

export const TaskListThreeDotsButton = ({position, top, left, onRemove, onEdit, vertical, customBackgroundColor, customThreeDotsColor})=>{
    const [hovered, setHovered] = useState(false)
    const onHover = (e) => {
        setHovered(true);
    }
    return <TaskListEditButtonWrapper $position={position} $top={top} $left={left} $hovered={hovered} $vertical={vertical} $customBackgroundColor={customBackgroundColor} onMouseLeave={(e)=>{
            setHovered(false);
        }}>
        <span onClick={hovered?onEdit:null}>
            <MdEdit />
        </span>
        <span onClick={hovered?onRemove:null}>
            <LuX />
        </span>
        <span onMouseEnter={onHover} >
            <BsThreeDots style={{color: customThreeDotsColor && !hovered ? customThreeDotsColor : ""}} />
        </span>
    </TaskListEditButtonWrapper>
}
export const ThreeDotsButton = ({
    disabled,
    onRemove,
    onEdit,
    onSync,
    position,
    right,
    syncInsteadRemove,
    editOnly,
    showSyncAndRemove,
    hideRemove,
    customButton,
}) => {
    const [hovered, setHovered] = useState(false);
    const [syncing, setSyncing] = useState(false);
    const syncIconRef = useRef(null);
    const pointerInsideRef = useRef(false);

    const menuExpanded = hovered || syncing;
    const showCustomButton =
        customButton &&
        customButton.icon != null &&
        typeof customButton.action === 'function';

    const finishSync = () => {
        setSyncing(false);
        if (!pointerInsideRef.current) {
            setHovered(false);
        }
    };

    const handleSyncClick = (e) => {
        e.stopPropagation();
        if (!menuExpanded || !onSync || syncing) return;
        const svgTag = syncIconRef.current?.querySelector('svg');
        const syncPromise = Promise.resolve(onSync());
        setSyncing(true);
        if (!svgTag) {
            syncPromise.finally(finishSync);
            return;
        }
        swapSVGWhileProcessing(
            () => syncPromise,
            svgTag,
            null,
            null,
            '0.1rem',
            'var(--gray)'
        );
        syncPromise.finally(finishSync);
    };

    const handleCustomButtonClick = (e) => {
        e.stopPropagation();
        if (!menuExpanded || !showCustomButton) return;
        customButton.action();
    };

    return <EditButtonWrapper
        $position={position}
        style={{ right: right }}
        $disabled={disabled}
        $hovered={menuExpanded}
        onMouseEnter={() => {
            pointerInsideRef.current = true;
            if (!disabled) {
                setHovered(true);
            }
        }}
        onMouseLeave={() => {
            pointerInsideRef.current = false;
            if (!syncing) {
                setHovered(false);
            }
        }}
    >
            <div>
                <div>
                    <span onClick={menuExpanded ? onEdit : null}>
                        <MdEdit />
                    </span>
                    {!editOnly &&
                        (showSyncAndRemove ? (
                            <>
                                <span ref={syncIconRef} onClick={handleSyncClick}>
                                    <IoMdSync />
                                </span>
                                {!hideRemove ? (
                                    <span onClick={menuExpanded ? onRemove : null}>
                                        <LuX />
                                    </span>
                                ) : null}
                            </>
                        ) : syncInsteadRemove ? (
                            <span ref={syncIconRef} onClick={handleSyncClick}>
                                <IoMdSync />
                            </span>
                        ) : (
                            <span onClick={menuExpanded ? onRemove : null}>
                                <LuX />
                            </span>
                        ))}
                    {showCustomButton ? (
                        <span onClick={handleCustomButtonClick}>{customButton.icon}</span>
                    ) : null}
                    <span>
                        <BsThreeDots />
                    </span>
                </div>
            </div>
        
    </EditButtonWrapper>
}
export const AddButton = ({action, inactive, customSize})=>{
    
    return <AddButtonWrapper $size={customSize} inactive={inactive}>
        <RiAddCircleFill  onClick={inactive?()=>{}:action} />
    </AddButtonWrapper>
} 

export const RemoveButton = ({action, disabled, customColor}) => {
    return <RmvBtn $disabled={disabled} $customcolor={customColor} onClick={!disabled?action:null}>
        <FaTimesCircle />
    </RmvBtn>
}
export const AddButtonWithTitle = ({title, onClick})=>{
    return <AddButtonWithText id='addButton' onClick={onClick?onClick:null}><IoMdAddCircle /> &nbsp; {title}</AddButtonWithText>
}
export const RemoveButtonTrashCan = ({action}) => {
    return <RmvBtn onClick={action}>
        <FaRegTrashAlt />
    </RmvBtn>
}


export const ButtonWithLoadingIcon = ({label, className, action, customSpinnerWidth, customSpinnerColor}) => {
    return <div className={`${className} non-selectable`}  onClick={(e)=>{
        e.stopPropagation();
        let target = e.target.tagName !== 'SPAN' ? e.target : e.target.parentElement;
        if(!target.className.includes(styles.loading)){
            target.classList.add(styles.loading);
            addAndRemoveLoadingIcon(target.childNodes[0], false, customSpinnerWidth, customSpinnerColor);
            action(()=>{
                addAndRemoveLoadingIcon(target.childNodes[0], true);
                target.className = target.className.replace(styles.loading, '');
            });
        }
    }}>
        <span>{label}</span>
    </div>
}
//